import { PartnersCard, TravelLoyaltyIcons } from 'src/components/pages/PartnersPage/types';

export const PAGE_ANCHOR_KEY = 'page_anchor';
export const MAIN_SCREEN_ANCHOR_KEY = 'main_screen_anchor';
export const CIRCLE_LOGO = 'https://static.solartrip.com/images/partners_landing/circle_logo.svg';
export const JOURNEY_BACKGROUND =
  'https://static.solartrip.com/images/partners_landing/journey_background.png';
export const JOURNEY_BACKGROUND_MOBILE =
  'https://static.solartrip.com/images/partners_landing/journey_background_mobile.png';
export const CHECK_ICON = 'https://static.solartrip.com/images/partners_landing/check_icon.svg';
export const PLAY_ICON = 'https://static.solartrip.com/images/partners_landing/play_icon.svg';
export const VIDEO_PLACEHOLDER =
  'https://static.solartrip.com/images/partners_landing/video_placeholder.jpg';

export const VIDEO_IFRAME_LINK =
  'https://www.youtube.com/embed/BUTOByuvL9E?si=p_CXfWQyW_GMvaQX&amp;controls=0';

const GATE_IO_IMAGE = 'https://static.solartrip.com/images/solartrip/partners/gate_io%402x.webp';
const KUCOIN_IMAGE = 'https://static.solartrip.com/images/solartrip/partners/kucoin%25402x.webp';
const YONDER_IMAGE = 'https://static.solartrip.com/images/solartrip/partners/yonder%25402x.webp';
const GATE_IO_IMAGE_MOBILE =
  'https://static.solartrip.com/images/solartrip/partners/gate_io_mobile.webp';
const KUCOIN_IMAGE_MOBILE =
  'https://static.solartrip.com/images/solartrip/partners/kucoin_mobile.webp';
const YONDER_IMAGE_MOBILE =
  'https://static.solartrip.com/images/solartrip/partners/yonder_mobile.webp';

export const GATE_IO_IMAGES = {
  sources: [],
  srcDesktop: GATE_IO_IMAGE,
  srcMobile: GATE_IO_IMAGE_MOBILE,
  alt: 'Gate IO App',
};

export const KUCOIN_IMAGES = {
  sources: [],
  srcDesktop: KUCOIN_IMAGE,
  srcMobile: KUCOIN_IMAGE_MOBILE,
  alt: 'KuCoin App',
};

export const YONDER_IMAGES = {
  sources: [],
  srcDesktop: YONDER_IMAGE,
  srcMobile: YONDER_IMAGE_MOBILE,
  alt: 'Yonder App',
};

export const GATE_IO_LINK = 'https://gateio.solartrip.com/';
export const YONDER_LINK = 'https://yonder.solartrip.com/';
export const KUCOIN_LINK = 'https://kucoin.solartrip.com/';

export const PRIVACY_POLICY_LINK =
  'https://support.solartrip.com/hc/en-gb/articles/4768495535133-Privacy-Policy';

export const TravelLoyaltyItems: Readonly<TravelLoyaltyIcons[]> = [
  {
    id: 1,
    icon: 'https://static.solartrip.com/images/solartrip/partners/icon_coins.webp',
    text: 'Banks',
  },
  {
    id: 2,
    icon: 'https://static.solartrip.com/images/solartrip/partners/icon_credit_cards.webp',
    text: 'Payment<br />Systems',
  },
  {
    id: 3,
    icon: 'https://static.solartrip.com/images/solartrip/partners/icon_crypto_coins.webp',
    text: 'Crypto<br />Exchanges',
  },
  {
    id: 4,
    icon: 'https://static.solartrip.com/images/solartrip/partners/icon_airplane.webp',
    text: 'Airlines',
  },
] as const;

export const ResultCards: Readonly<PartnersCard[]> = [
  {
    id: 1,
    title: 'Feel the power of loyalty',
    subTitle: '88% of clients are likely to recommend a travel loyalty program',
    icon: 'https://static.solartrip.com/images/partners_landing/cards_images/card_image_1.svg',
  },
  {
    id: 2,
    title: 'Boost cards issuance',
    subTitle: 'Travel offering increases card issuance by 40%',
    icon: 'https://static.solartrip.com/images/partners_landing/cards_images/card_image_2.svg',
  },
  {
    id: 3,
    title: 'Power up transactions',
    subTitle: '30% higher payment volumes vs. cards with no rewards',
    icon: 'https://static.solartrip.com/images/partners_landing/cards_images/card_image_3.svg',
  },
] as const;

export const JourneyBlock = [
  {
    id: 1,
    data: 'We develop and customize the platform to meet your guidelines',
  },
  {
    id: 2,
    data: 'Your clients can earn and redeem points for travel with our loyalty software',
  },
  {
    id: 3,
    data: 'We take care of your clients with\u00A0AI\u2011powered customer support',
  },
  {
    id: 4,
    data: 'We provide technical support, platform updates and account management',
  },
  {
    id: 5,
    data: 'Your travel loyalty can be embedded in your website and app in 2-4 months',
  },
  {
    id: 6,
    data: 'You earn up to 10% commission when your customers book stays via\u00A0platform',
  },
] as const;

export const KeyFeaturesCards: Readonly<PartnersCard[]> = [
  {
    id: 1,
    title: 'Wide choice and<br />flexibility',
    subTitle:
      '2M+ of accommodation options with more than 2,000 hotel chains from 150+ providers and direct hotels<br /><br />800+ airlines and 100+ low-cost carriers through our integrations  with top carriers and global distribution systems',
    icon: 'https://static.solartrip.com/images/partners_landing/cards_images/features_card_1_v2.png',
  },
  {
    id: 2,
    title: 'Customer loyalty<br />software',
    subTitle:
      'Cashback for travel purchases on the platform<br /><br/>Bonuses accrual for spendings on and outside the travel platform<br /><br/>Bonus points and promo codes redemption for stays and flights',
    icon: 'https://static.solartrip.com/images/partners_landing/cards_images/features_card_2.png',
  },
  {
    id: 3,
    title: 'NEO advantages',
    subTitle:
      'ML-powered search engine<br /><br/>Customer support with embedded AI<br /><br/>Automated changes and cancellations<br /><br/>Personalized offers<br /><br/>Seamless UX/UI',
    icon: 'https://static.solartrip.com/images/partners_landing/cards_images/features_card_3.png',
  },
] as const;

export const PartnersLogos = [
  {
    id: 1,
    logo: 'https://static.solartrip.com/images/solartrip/partners/expedia.svg',
  },
  {
    id: 2,
    logo: 'https://static.solartrip.com/images/solartrip/partners/tripcom.svg',
  },
  {
    id: 3,
    logo: 'https://static.solartrip.com/images/solartrip/partners/agoda.svg',
  },
  {
    id: 4,
    logo: 'https://static.solartrip.com/images/solartrip/partners/bookingcom.svg',
  },
  {
    id: 5,
    logo: 'https://static.solartrip.com/images/partners_landing/partners_logos/travelfusion.svg',
  },
  {
    id: 6,
    logo: 'https://static.solartrip.com/images/partners_landing/partners_logos/travelport.svg',
  },
  {
    id: 7,
    logo: 'https://static.solartrip.com/images/partners_landing/partners_logos/sabre.svg',
  },
  {
    id: 8,
    logo: 'https://static.solartrip.com/images/partners_landing/partners_logos/amadeus.svg',
  },
  {
    id: 9,
    logo: 'https://static.solartrip.com/images/partners_landing/partners_logos/farelogix.svg',
  },
] as const;

export const CompletedProjectsData = [
  {
    id: 1,
    number: '35',
    text: 'banks',
  },
  {
    id: 2,
    number: '50+',
    text: 'travel platforms',
  },
  {
    id: 3,
    number: '50M+',
    text: 'travel loyalty members',
  },
] as const;
